import { ReactNode } from 'react'
import { SentryFeedback } from 'components/global'

type SentryProviderProps = {
  children: ReactNode
}

/**
 * SentryProvider component for rendering the SentryFeedback widget
 * at the application level
 *
 * @param {ReactNode} children - Child components to render
 * @returns React component
 */
export const SentryProvider = ({ children }: SentryProviderProps) => {
  return (
    <>
      {/* Sentry Feedback component - only shows for superAdmin users */}
      <SentryFeedback />
      {children}
    </>
  )
}

export default SentryProvider
